import EditorialSection from 'components/EditorialSection';
import Section from 'components/Section';
import { forwardRef } from 'react';
import './index.css';

const contactLinks = [
  {
    label: 'LinkedIn',
    mono: 'LINKEDIN',
    href: 'https://www.linkedin.com/in/sebastien-friedberg/',
    display: 'linkedin.com/in/sebastien-friedberg',
    external: true,
  },
  {
    label: 'GitHub',
    mono: 'GITHUB',
    href: 'https://github.com/SebastienGt',
    display: 'github.com/SebastienGt',
    external: true,
  },
];

const Contact = forwardRef(({ id, sectionRef }, ref) => (
  <Section
    className="contact"
    as="section"
    id={id}
    ref={sectionRef || ref}
    aria-labelledby={`${id}-title`}
    tabIndex={-1}
  >
    <EditorialSection
      index={6}
      eyebrow="Contact"
      title="Get in touch"
      headingId={`${id}-title`}
    />
    <p className="contact__lede">
      I'm always open to interesting projects and conversations.
      Reach out and let's build something.
    </p>
    <ul className="contact__list">
      {contactLinks.map(link => (
        <li key={link.label} className="contact__item">
          <a
            className="contact__link"
            href={link.href}
            {...(link.external
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {})}
          >
            <span className="contact__link-label">{link.mono}</span>
            <span className="contact__link-value">
              {link.display}
              <span className="contact__link-arrow" aria-hidden>→</span>
            </span>
          </a>
        </li>
      ))}
    </ul>
  </Section>
));

export default Contact;
